// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowPreview-cls1_vXg","cls2":"BulkFollowPreview-cls2_JQn BulkFollowPreview-cls1_vXg","compact":"BulkFollowPreview-compact_FmU"};